import { ChangeDetectorRef, Component, DestroyRef, ElementRef, inject, Input, OnDestroy, OnInit } from "@angular/core";
import { WorlistItemService } from "#services/api/worklist-item.service";
import { ActivityMetrics } from "#models/activities/activity.model";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
@Component({
  selector: "app-overriden-activities-info",
  templateUrl: "./overriden-activities-info.component.html",
  styleUrls: ["./overriden-activities-info.component.scss"],
  standalone: false,
})
export class OverridenActivitiesInfoComponent implements OnInit, OnDestroy {
  @Input()
  _worklistItemid: string;
  _appliedjobtemplateID: string;

  _NormsNonOverridenPercentage: number;
  worklistItemActivitiesMetrics: ActivityMetrics;
  destroyRef = inject(DestroyRef);
  private _observer?: IntersectionObserver;
  private _loaded = false;

  constructor(
    private readonly _worklistItemSvc: WorlistItemService,
    private readonly _el: ElementRef<HTMLElement>,
    private readonly cdr: ChangeDetectorRef) {}

  @Input()
  private set WorklistItemid1(worklistItemid: string) {
    this._worklistItemid = worklistItemid;
  }

  @Input()
  private set AppliedjobtemplateID(appliedjobtemplateID: string) {
    this._appliedjobtemplateID = appliedjobtemplateID;
  }

  ngOnInit() {
    // Lazy-load: only fetch the overridden % when the row scrolls into view.
    if (typeof IntersectionObserver === "undefined") {
      this.getInfo(this._worklistItemid, this._appliedjobtemplateID);
      return;
    }

    this._observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.getInfo(this._worklistItemid, this._appliedjobtemplateID);
        }
      },
      { rootMargin: "100px" },
    );
    this._observer.observe(this._el.nativeElement);
  }

  ngOnDestroy(): void {
    this._observer?.disconnect();
  }

  get normsNonOverridenPercentage(): number {
    const value = Number(this._NormsNonOverridenPercentage || 0);
    if (value < 0) {
      return 0;
    }
    if (value > 100) {
      return 100;
    }
    return Math.round(value);
  }

  getInfo(worklistItemid: string, appliedjobtemplateID: string): void {
    // Fetch once; stop observing after the first in-view load.
    if (this._loaded) {
      return;
    }
    this._loaded = true;
    this._observer?.disconnect();

    this._worklistItemSvc
      .getWorklistItemActivitiesMetrics(worklistItemid, appliedjobtemplateID)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((activityMetrics) => {
        if (!activityMetrics) return;
        this.worklistItemActivitiesMetrics = activityMetrics;
        this._NormsNonOverridenPercentage =
          activityMetrics.OverridenActivitiesPercentage;
          this.cdr.detectChanges();
      });
  }
}
